export default "__VITE_ASSET__B2laauM2__"